import { useSuspenseQuery } from '@tanstack/react-query'
import { apiClient } from '~/shared/api/data-ingestion-api'

export function useExtractedDataReviews({ documentKey }: { documentKey: string }) {
  return useSuspenseQuery({
    ...apiClient.getDocumentExtractedDataReviewDocumentsKeyExtractedDataReviewsGetOptions({
      path: { key: documentKey },
    }),
  })
}
